import React, { useEffect, useState } from 'react';

const Toast = ({ message }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (message) {
            setIsVisible(true);
        }
    }, [message]);

    if (!message) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: `translateX(-50%) translateY(${isVisible ? '0' : '-100%'})`,
            backgroundColor: '#FEE2E2',
            padding: '12px 24px',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            color: '#DC2626',
            fontSize: '14px',
            zIndex: 1000,
            maxWidth: '90%',
            textAlign: 'center',
            transition: 'transform 0.3s ease-in-out',
            animation: 'slideIn 0.3s ease-in-out'
        }}>
            <style>
                {`
                    @keyframes slideIn {
                        from {
                            transform: translateX(-50%) translateY(-100%);
                        }
                        to {
                            transform: translateX(-50%) translateY(0);
                        }
                    }
                `}
            </style>
            {message}
        </div>
    );
};

export default Toast; 